import * as React from "react";
import { Card, CardContent } from "@/components/ui/card";
import type { AuditEntry } from "./helpers";

interface AuditDiffCardProps {
  entry: AuditEntry;
}

export function AuditDiffCard({ entry }: AuditDiffCardProps): React.ReactElement {
  return (
    <Card className="animate-scale-in mt-4">
      <CardContent className="pt-6">
        <pre className="bg-muted overflow-x-auto rounded-md p-3 text-xs">
          {JSON.stringify({ before: entry.before, after: entry.after }, null, 2)}
        </pre>
      </CardContent>
    </Card>
  );
}
